import { Navigate } from 'react-router-dom';
import { useUser, SignedIn, SignedOut, SignInWidget, IS_DEMO_MODE } from '@/lib/auth';

/**
 * Page de connexion : email magic link uniquement (pas d'OAuth pour le launch).
 * Après auth, redirection vers `/` qui résout le tenant via useTenant().
 */
export function SignInPage() {
  const { isLoaded } = useUser();

  if (!isLoaded) {
    return <div className="min-h-screen flex items-center justify-center">Chargement…</div>;
  }

  if (IS_DEMO_MODE) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <SignedIn>
        <Navigate to="/" replace />
      </SignedIn>
      <SignedOut>
        <div className="min-h-screen bg-ducens-bg flex items-center justify-center p-6">
          <div className="w-full max-w-md">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-ducens-ink text-ducens-accent text-xl font-bold mb-4">
                D
              </div>
              <h1 className="text-2xl font-semibold mb-1">Ducens</h1>
              <p className="text-sm text-ducens-muted">
                Connecte-toi avec l'email utilisé pour ton paiement.
                <br />
                Tu recevras un lien magique — pas de mot de passe.
              </p>
            </div>
            <SignInWidget />
            <p className="text-xs text-ducens-muted text-center mt-6">
              Une question ? Écris à{' '}
              <a href="mailto:sebastian@ducens.io" className="underline">
                sebastian@ducens.io
              </a>
            </p>
          </div>
        </div>
      </SignedOut>
    </>
  );
}
